module.exports = __webpack_public_path__ + "static/img/logo.51448b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/logo.png
// module id = OelD
// module chunks = 1